export const LOT_LOAD = 'lot_load';



// WEBPACK FOOTER //
// ./src/redux/actions/types/LotTypes.js